<template>
    <div>
        <div class="form-check p-2" style="border: 1px solid #c0c0c0; border-radius:10px; ">
            <input class="form-check-input" type="checkbox" value="1"
                   id="inspections_only" style="margin-left: 0px;" v-model="checked">
            <label class="form-check-label" for="inspections_only">
                {{ label }}
            </label>
        </div>
        <input :id="name" v-model="valueChecked" :name="name" type="hidden">
    </div>
</template>

<script>

export default {
    name: "CheckboxComponent",
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            checked: false,
            valueChecked: 0
        }
    },
    watch: {
      checked (val){
            this.valueChecked =  val ? 1 : 0;
      }
    },
    mounted() {
        if (this.value == 1){
            this.checked = true;
        }else{
            this.checked = false;
        }
    },
}
</script>

<style scoped>

</style>
